module.exports = __webpack_public_path__ + "img/ltktravel-2x.2a2f08f.jpg";